import { DefaultButton, FocusTrapZone, Layer, Popup, PrimaryButton, Stack, Text } from "@fluentui/react";
import { lgPopupContentStyles, lgResendButtonStyles as lgDismissButtonStyles, lgSubTitleStyles, lgTitleStyles, lgValidateButtonStyles as lgSuccessButtonStyles, mdPopupContentStyles, mdResendButtonStyles as mdDismissButtonStyles, mdSubTitleStyles, mdTitleStyles, mdValidateButtonStyles as mdSuccessButtonStyles, popupContainerStyles, popupContentStyles, resendButtonStyles as dismissButtonStyles, smPopupContentStyles, smResendButtonStyles as smDismissButtonStyles, smSubTitleStyles, smTitleStyles, smValidateButtonStyles as smSuccessButtonStyles, subTitleStyles, titleStyles, validateButtonStyles as successButtonStyles, xlPopupContentStyles, xlResendButtonStyles as xlDismissButtonStyles, xlSubTitleStyles, xlTitleStyles, xlValidateButtonStyles as xlSuccessButtonStyles, xxlPopupContentStyles, xxlResendButtonStyles as xxlDismissButtonStyles, xxlSubTitleStyles, xxlTitleStyles, xxlValidateButtonStyles as xxlSuccessButtonStyles, titleContainerStyles, contentContainerStyles } from "./Styles/RegisterHelpPopupStilyes";
import { t } from "i18next";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { BreakpointType } from "../../../Container/ContainerFluid";
import { Trans } from "react-i18next";

export interface IRegisterHelpPopupProps {
    hidden: boolean;
    saveInProgress: boolean;
    onSuccess: () => void;
    onDismiss: () => void;
}

export const RegisterHelpPopup: React.FC<IRegisterHelpPopupProps> = (props: IRegisterHelpPopupProps) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <>
            {
                props.hidden ?
                    <></>
                :
                    <Layer>
                        <Popup
                            className={popupContainerStyles}
                            role="dialog"
                            aria-modal="true"
                        >
                            <FocusTrapZone>
                                <Stack
                                    className={
                                        isSM ? 
                                            smPopupContentStyles :
                                        isMD ?
                                            mdPopupContentStyles :
                                        isLG ?
                                            lgPopupContentStyles :
                                        isXL ?
                                            xlPopupContentStyles :
                                        isXXL ?
                                            xxlPopupContentStyles 
                                        :
                                            popupContentStyles
                                    }
                                >
                                    <Stack
                                        className={titleContainerStyles}
                                        verticalFill
                                        verticalAlign="space-around"
                                    >
                                        <Text
                                            className={
                                                isSM ? 
                                                    smTitleStyles :
                                                isMD ? 
                                                    mdTitleStyles :
                                                isLG ? 
                                                    lgTitleStyles :
                                                isXL ?
                                                    xlTitleStyles :
                                                isXXL ?
                                                    xxlTitleStyles
                                                :
                                                    titleStyles
                                            }
                                        >
                                            {t("common:register:helpTitle")}
                                        </Text>
                                        <Text
                                            className={
                                                isSM ? 
                                                    smSubTitleStyles :
                                                isMD ? 
                                                    mdSubTitleStyles :
                                                isLG ?
                                                    lgSubTitleStyles :
                                                isXL ?
                                                    xlSubTitleStyles :
                                                isXXL ?
                                                    xxlSubTitleStyles
                                                :
                                                    subTitleStyles
                                            }
                                        >
                                            <Trans
                                                i18nKey="common:register:helpDescription"
                                                components={[<strong />]}
                                            />
                                        </Text>
                                    </Stack>
                                    <Stack
                                        verticalFill
                                        verticalAlign="end"
                                        className={contentContainerStyles}
                                    >
                                        <Stack
                                            horizontal
                                            horizontalAlign="space-between"
                                        >
                                            <DefaultButton
                                                onClick={() => props.onDismiss()}
                                                disabled={props.saveInProgress}
                                                styles={
                                                    isSM ?
                                                        smDismissButtonStyles :
                                                    isMD ?
                                                        mdDismissButtonStyles :
                                                    isLG ?
                                                        lgDismissButtonStyles :
                                                    isXL ?
                                                        xlDismissButtonStyles :
                                                    isXXL ?
                                                        xxlDismissButtonStyles
                                                    :
                                                        dismissButtonStyles
                                                }
                                            >
                                                {t("common:register:helpDismiss")}
                                            </DefaultButton>
                                            <PrimaryButton
                                                onClick={() => props.onSuccess()}
                                                disabled={props.saveInProgress}
                                                styles={
                                                    isSM ?
                                                        smSuccessButtonStyles :
                                                    isMD ?
                                                        mdSuccessButtonStyles :
                                                    isLG ?
                                                        lgSuccessButtonStyles :
                                                    isXL ?
                                                        xlSuccessButtonStyles :
                                                    isXXL ?
                                                        xxlSuccessButtonStyles
                                                    :
                                                        successButtonStyles
                                                }
                                            >
                                                {t("common:register:helpSuccess")}
                                            </PrimaryButton>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </FocusTrapZone>
                        </Popup>
                    </Layer>
            }
        </>
    );
};